import React from 'react';

export const ResponsiveFormLabel = ({ children, className = '', ...props }) => (
    <label className={`font-bold mb-1 col-span-3 ${className}`} {...props}>
        {children}
    </label>
);

export const ResponsiveFormInput = ({ children, className = '', ...props }) => (
    <div className={`col-span-2 ${className} [&>*]:w-full [&_input]:w-full`} {...props}>
        {children}
    </div>
);

export const ResponsiveFormField = ({ children, className = '', ...props }) => (
    <div className={`grid grid-cols-1 gap-2 pb-2 mx-12 mt-2 sm:grid-cols-5 sm:items-center ${className}`} {...props}>
        {children}
    </div>
);
